// extracted by mini-css-extract-plugin
module.exports = {"infoandheaderheight":"215","ghanimationtime":"500","ghanimationsize":"650"};